export default [
  {
    title: '投放位',
    key: 'advPositionName',
    width: 226,
    type: 'report'
  },
  {
    title: '账面消耗',
    key: 'paperConsume',
    width: 98,
    type: 'report'
  },
  {
    title: '实际消耗',
    key: 'realConsume',
    width: 102,
    type: 'report'
  },
  {
    title: '曝光',
    key: 'pv',
    width: 102,
    type: 'report'
  },
  {
    title: '点击数',
    key: 'clickNum',
    width: 82,
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: 82,
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: 82,
    type: 'report'
  },
  {
    title: '注册数',
    key: 'registerNum',
    width: 82,
    type: 'report'
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    width: 82,
    type: 'report'
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    width: 82,
    type: 'report'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 82,
    type: 'report'
  },
  {
    title: '创角率',
    key: 'newRoleRate',
    width: 82,
    type: 'report'
  },
  {
    title: '新增付费创角数',
    key: 'payRole1d',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt1d',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角付费成本',
    key: 'payRoleCost1d',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角付费率',
    key: 'payRoleRate1d',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角充值金额',
    key: 'natureTimeNewRoleMoney',
    width: 102,
    type: 'report'
  },
  {
    title: '每次付费成本',
    key: 'payRoleEveryCost1d',
    width: 102,
    type: 'report'
  },
  {
    title: '计划总流水',
    key: 'totalMoney',
    width: 92,
    type: 'report'
  },
  {
    title: '新创角回款率',
    key: 'natureTimeNewRoleRoi',
    width: 92,
    type: 'report'
  },
  {
    title: '创角次留',
    key: 'createRoleRetain2d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角3留',
    key: 'createRoleRetain3d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角4留',
    key: 'createRoleRetain4d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角5留',
    key: 'createRoleRetain5d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角6留',
    key: 'createRoleRetain6d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角7留',
    key: 'createRoleRetain7d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角15留',
    key: 'createRoleRetain15d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角30留',
    key: 'createRoleRetain30d',
    width: 72,
    type: 'other'
  },
  {
    title: '创角1日LTV',
    key: 'createRoleLtv1d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角2日LTV',
    key: 'createRoleLtv2d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角3日LTV',
    key: 'createRoleLtv3d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角4日LTV',
    key: 'createRoleLtv4d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角5日LTV',
    key: 'createRoleLtv5d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角6日LTV',
    key: 'createRoleLtv6d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角7日LTV',
    key: 'createRoleLtv7d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角15日LTV',
    key: 'createRoleLtv15d',
    width: 92,
    type: 'other'
  },
  {
    title: '创角30日LTV',
    key: 'createRoleLtv30d',
    width: 92,
    type: 'other'
  }
]
